import { BlogDecorator } from './decorators/BlogDecorators';
import { CareersDecorator } from './decorators/CareersDecorators';
import { DefaultDecorator } from './decorators/DefaultDecorator';
import { ErrorDecorator } from './decorators/ErrorDecorator';
import { NumbersDecorator } from './decorators/NumbersDecorator';
import { NumbersNoMobileDecorator } from './decorators/NumbersNoMobileDecorator';
import { TestimonialDecorator } from './decorators/TestimonialDecorators';

export const decorators = {
  careers: CareersDecorator,
  blog: BlogDecorator,
  default: DefaultDecorator,
  error: ErrorDecorator,
  numbers: NumbersDecorator,
  numbersNoMobile: NumbersNoMobileDecorator,
  testimonial: TestimonialDecorator,
};

export type DecoratorWrapperVariant = keyof typeof decorators;
